export const withUnitNumber = (formattedAddress: string, unitNumber: string): string => {
  if (!unitNumber) return formattedAddress;

  const [streetPart, ...rest] = formattedAddress.split(', ');

  if (streetPart.startsWith(`${unitNumber}-`)) return formattedAddress;

  return [`${unitNumber}-${streetPart}`, ...rest].join(', ');
};
